import { Radio } from "@material-ui/core";

import styles from "../createGame.module.css";
import { translate } from "../../../../translations/index.ts";

export default function QuestionSetStep({
  template,
  setQuestionSet,
  questionSets,
}) {
  return (
    <>
      <h3 className={styles.stepTitle}>
        {translate("teacher.gameSettings.steps.questionSet.label")}
      </h3>
      <div className={styles.optionsContainer}>
        {questionSets.map((questionSet) => (
          <div className={styles.optionContainer} key={questionSet._id}>
            <div className={styles.optionControlWrapper}>
              <Radio
                name="question-set"
                value={questionSet._id}
                id={`set-${questionSet._id}`}
                checked={template.questionSet === questionSet._id}
                onChange={() => setQuestionSet(questionSet._id)}
              />
            </div>
            <div className={styles.optionContentWrapper}>
              <label htmlFor={`set-${questionSet._id}`}>
                <span className={styles.optionName}>{questionSet.name}</span>
                {questionSet.description &&
                  questionSet.description.length > 0 && (
                    <span className={styles.optionDescription}>
                      {questionSet.description}
                    </span>
                  )}
              </label>
              <div style={{ marginLeft: "auto", marginRight: "24px" }}>
                {questionSet.statements.length}{" "}
                {translate("general_statements")}
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
